import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';
import { NotificationBar } from '@eb/eds-notification';

const AuthNotification = ({ authNotificationOptions }) => {
    let component = null;

    if (!isEmpty(authNotificationOptions)) {
        const { message, ...props } = authNotificationOptions;

        component = (
            <div className="eds-l-mar-bot-4 authentication__notification-container">
                <NotificationBar {...props}>{message}</NotificationBar>
            </div>
        );
    }

    return component;
};

AuthNotification.propTypes = {
    authNotificationOptions: PropTypes.shape({
        message: PropTypes.node,
        type: PropTypes.string,
        iconType: ICON_TYPE_PROP_TYPE,
    }),
};

export default AuthNotification;
